import * as e from "react";
import { forwardRef as t } from "react";
const o = t(function(C, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...C
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M12.4684 20.6342C12.4684 20.7542 12.4684 20.8641 12.5186 20.984C11.183 21.0653 9.84674 20.836 8.6154 20.3144C8.03742 20.0755 7.48593 19.7774 6.96984 19.4249C5.25681 18.2401 3.97814 16.5314 3.32752 14.5577L3.64861 14.4678C5.60937 14.0453 7.65791 14.4782 9.27764 15.6571C9.56292 15.8552 9.83446 16.0722 10.0904 16.3067C11.3212 17.4635 12.1535 18.9781 12.4684 20.6342ZM14.124 7.64175C14.3735 7.87239 14.6384 8.08608 14.9167 8.28138C16.5133 9.43489 18.5262 9.85984 20.4554 9.4507L20.7765 9.36076C20.1407 7.41756 18.8868 5.73353 17.2044 4.56354C16.7011 4.21614 16.1631 3.92142 15.599 3.68405C14.3874 3.16704 13.0718 2.9378 11.756 3.01444C11.756 3.13437 11.756 3.2443 11.756 3.36423C12.0723 5.00264 12.9054 6.49771 14.134 7.63176L14.124 7.64175ZM10.251 14.6377C10.4316 14.7576 10.6122 14.8676 10.7828 14.9975C12.4959 16.2943 13.6793 18.1654 14.114 20.2644C14.114 20.3944 14.114 20.5343 14.1742 20.6642C18.6772 19.572 21.5955 15.2334 20.897 10.67C18.4469 11.1563 15.9041 10.6099 13.8732 9.16087L10.251 14.6377ZM13.8732 9.16087C13.6825 9.02096 13.4818 8.89103 13.3012 8.74112C11.7605 7.46142 10.6996 5.70029 10.291 3.74401C10.291 3.6041 10.291 3.46418 10.2308 3.32426C5.51541 4.2443 2.37072 8.70884 3.10676 13.4384L3.50812 13.3385C5.83904 12.8586 8.2659 13.3148 10.2609 14.6077L13.8732 9.16087Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "mask",
      {
        height: 18,
        maskUnits: "userSpaceOnUse",
        style: {
          maskType: "luminance"
        },
        width: 18,
        x: 3,
        y: 3
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M12.4684 20.6342C12.4684 20.7542 12.4684 20.8641 12.5186 20.984C11.183 21.0653 9.84674 20.836 8.6154 20.3144C8.03742 20.0755 7.48593 19.7774 6.96984 19.4249C5.25681 18.2401 3.97814 16.5314 3.32752 14.5577L3.64861 14.4678C5.60937 14.0453 7.65791 14.4782 9.27764 15.6571C9.56292 15.8552 9.83446 16.0722 10.0904 16.3067C11.3212 17.4635 12.1535 18.9781 12.4684 20.6342ZM14.124 7.64175C14.3735 7.87239 14.6384 8.08608 14.9167 8.28138C16.5133 9.43489 18.5262 9.85984 20.4554 9.4507L20.7765 9.36076C20.1407 7.41756 18.8868 5.73353 17.2044 4.56354C16.7011 4.21614 16.1631 3.92142 15.599 3.68405C14.3874 3.16704 13.0718 2.9378 11.756 3.01444C11.756 3.13437 11.756 3.2443 11.756 3.36423C12.0723 5.00264 12.9054 6.49771 14.134 7.63176L14.124 7.64175ZM10.251 14.6377C10.4316 14.7576 10.6122 14.8676 10.7828 14.9975C12.4959 16.2943 13.6793 18.1654 14.114 20.2644C14.114 20.3944 14.114 20.5343 14.1742 20.6642C18.6772 19.572 21.5955 15.2334 20.897 10.67C18.4469 11.1563 15.9041 10.6099 13.8732 9.16087L10.251 14.6377ZM13.8732 9.16087C13.6825 9.02096 13.4818 8.89103 13.3012 8.74112C11.7605 7.46142 10.6996 5.70029 10.291 3.74401C10.291 3.6041 10.291 3.46418 10.2308 3.32426C5.51541 4.2443 2.37072 8.70884 3.10676 13.4384L3.50812 13.3385C5.83904 12.8586 8.2659 13.3148 10.2609 14.6077L13.8732 9.16087Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      )
    ),
    /* @__PURE__ */ e.createElement("g", { mask: "url(#prefix__mask0_47_637)" })
  );
});
export {
  o as Tennis
};
